export const GetUserByAcct = {
    endpoint: "/users/by-acct/:user_acct",
    pathParams: ["user_acct"],
    method: "GET",
    request: undefined,
    response: undefined,
    paginated: false
};
//# sourceMappingURL=GetUserByAcct.js.map